import { Form } from 'factorial-form'

class AttendanceSettingForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      name: 'string',
      description: 'string',
      enabled: 'boolean',
      default: 'boolean',
      effective_at: 'string',
      desktop_clockin: 'boolean',
      mobile_clockin: 'boolean',
      enable_clock_in_location: 'boolean',
      enable_breaks: 'boolean',
      geolocation: 'boolean',
      geofencing: 'boolean',
      geolocation_block: 'boolean',
      qr_code_clockin: 'boolean',
      face_recognition: 'boolean',
      id_clock_shared_device: 'boolean',
      overtime_authorization: 'boolean',
      edit_timesheet_authorization: 'boolean',
      autofill_timesheet: 'boolean',
      employee_access_search_field: 'string',
      forgot_clock_out: 'string',
      forgot_clock_out_tolerance_minutes: 'number',
      extra_hours_baseline: 'string',
      complementary_hours_baseline: 'string',
      enable_complementary_hours: 'boolean',
      extra_hours_transfer_frequency: 'string',
      public_token: 'string',
      missing_clock_in_alert: 'boolean',
    })
  }
}

export default AttendanceSettingForm
